/**
 * iter 51 — Org-Admin Drawer (slim wrapper).
 *
 * Wraps the reusable OrgAdminContent in a sliding Drawer. Used by the
 * Organizations page when a partner-linked row is clicked.
 */
import { Drawer } from "../UI";
import OrgAdminContent from "./OrgAdminContent";

export default function OrgAdminDrawer({ open, onClose, orgId, orgName }) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={orgName || "Organization"}
      size="wide"
      testid="org-admin-drawer"
    >
      <OrgAdminContent
        orgId={orgId}
        orgName={orgName}
        active={open}
      />
    </Drawer>
  );
}
